import React from 'react';
import './FieldPlayersMismatchModal.css';
import PageButton from '../../elements/PageButton/PageButton';

const PAGE_ID = 'FieldPlayersMismatchModal';

function FieldPlayersMismatchModal({message, onHide}) {
  return (
    <div className="field-players-mismatch-overlay" onClick={onHide} role="dialog" aria-modal="true">
      <div className="field-players-mismatch-modal" onClick={(e) => e.stopPropagation()}>
        <h2 className="field-players-mismatch-title">Поле не подходит</h2>
        <p className="field-players-mismatch-text">{message}</p>
        <p className="field-players-mismatch-hint">
          Скорректируйте выбор поля или количество игроков в лобби и попробуйте снова.
        </p>
        <div className="main-menu-buttons field-players-mismatch-buttons">
          <PageButton onClick={onHide} pageId={PAGE_ID} buttonId="hide">
            Понятно
          </PageButton>
        </div>
      </div>
    </div>
  );
}

export default FieldPlayersMismatchModal;
